<script setup lang="ts">
import { useField } from 'vee-validate';
import DateTimePicker from './DateTimePicker.vue';
import type { VeeDateTimePickerProps } from '../types';
import { computed, toRef } from 'vue';
import { DateTime } from 'luxon';
import { toUserTime } from '@/components/formatters/utils';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeDateTimePickerProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, meta } = useField<string | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const { value: timeZone, handleChange: handleChangeTimeZone } = useField<string | undefined>(
  toRef(() => props.dataTimeZoneName),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const modelValue = computed(() => toUserTime(value.value, timeZone.value));

function onUpdate(input: DateTime | undefined) {
  handleChange(input?.toISO(), meta.touched);
  handleChangeTimeZone(input?.zoneName);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <DateTimePicker
    v-bind="veeProps"
    :modelValue="modelValue"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
